import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { createAuthBaseQuery } from "@/app/api/baseQuery";
import { ALL_API_TAGS } from "@/app/constants/apiTags.constants";
import { env } from "@/app/utils/env";
import { stopCacheInvalidationOnErrorResponses } from "@/utils/api/preventCacheInvalidation";

/**
 * Base API instance used for authenticated endpoint modules.
 */
const baseApi = createApi({
  reducerPath: "api",
  baseQuery: createAuthBaseQuery(),
  tagTypes: ALL_API_TAGS,
  refetchOnFocus: true,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 15,
  endpoints: () => ({}),
});

// Patch authenticated API to stop cache invalidation on error responses
stopCacheInvalidationOnErrorResponses(baseApi);

export { baseApi };

/**
 * Base API instance used for unauthenticated endpoint modules.
 */
export const baseApiNoAuth = createApi({
  reducerPath: "apiNoAuth",
  baseQuery: fetchBaseQuery({
    baseUrl: env.BACKEND_URL,
    credentials: "include",
  }),
  tagTypes: ALL_API_TAGS,
  endpoints: () => ({}),
});

// Patch unauthenticated API to stop cache invalidation on error responses
stopCacheInvalidationOnErrorResponses(baseApiNoAuth);

export const { reducer: apiReducer, middleware: apiMiddleware } = baseApi;

export const { reducer: apiNoAuthReducer, middleware: apiNoAuthMiddleware } =
  baseApiNoAuth;
